





















































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Thdata from "../../../store/entities/thdata";
import Echarts from "../threaltimedata/Echarts.vue";
import EchartsHumi from "../threaltimedata/Echarts.vue";
import PageRequest from "@/store/entities/page-request";
// import echarts from 'Echarts'
Vue.prototype.$echarts = Echarts;
class PageThRealTimeDataRequest extends PageRequest {
  AddTime: Date = new Date();
  mac:String;
  locationName: String;
  StartDate:Date = new Date();
  EndDate:Date=new Date();
  timetype:Number = 0;
  Id:Number;
}
@Component({
  components: { Echarts, EchartsHumi },
})
export default class AnalyseThrealtimedata extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Date }) EndTime: Date;
  @Prop({ type: String }) locationName: String;
  pagerequest: PageThRealTimeDataRequest = new PageThRealTimeDataRequest();
  componentKey: number = 10;
  componentKeyhumi: number = 10;
  mac = "";
  eqid = 0;
  datalist = [];
  legenddata: string = "";
  xAxisdata: string = "";
  temphxAxisdata:string = "";
  seriesdata: string = "";
  humiseriesdata: string = "";
  numberseriesdata:string = "";
  yAxisdata: string = "";
  serieslist = [];
  humiserieslist = [];
  numberserieslist = [];
  humistrtitle: string = "";
  numberstrtitle:string = "";
  yAxislist = [];
  thdata: Thdata = new Thdata();
  StartTime: string;
  list = [];
  strtitle: string = "";
  title: string = "数据分析";
  tempmessage: string = "";
  humimessage: string = "";
  numbermessage: string = "";
  datetype:string='day';
  startDate:Date=new Date();
  endDate:Date=new Date();
  monthDate:Date=new Date();
  polar:string="";
  maxtemp:string="";
  mintemp:string="";
  maxhumi:string="";
  minhumi:string="";
  MaxNumber:string = "";
  async getPage() {
    //filters
    //debugger;
    //let ss=this.value;
  if(this.pagerequest.timetype != 1){
    this.pagerequest.StartDate = this.EndTime;
    this.pagerequest.EndDate = this.EndTime;
    }
    this.pagerequest.AddTime = this.EndTime;
    this.pagerequest.mac = this.mac;
    this.list = await this.$store.dispatch({
      type: "data/getPagedLast",
      data: this.pagerequest,
    });
    var temphlist =  await this.$store.dispatch({
      type: "trapthdata/getPagedLast",
      data: this.pagerequest,
    });
    console.log(temphlist);
    //this.ThisThPaged();
    this.strtitle = "温度走势图";
    this.humistrtitle = "湿度走势图";
    this.numberstrtitle = "虫子数量走势图";
    let titlelist = ["环境温湿度"];

    this.serieslist.push({
      name: "温度",
      type: "line",
      data: [],
      areaStyle: {
        opacity: 0.8,
        color: {
          colorStops: [{ 
            offset: 0,
             color: "rgba(1,191,236)"
          },{ 
            offset: 1,
            color: "rgba(84, 112, 198)"
           
          }
          ],
           x: 0,
           y: 0,
           x2: 0,
           y2: 1,
          type: "linear",
          global:false
        }
        
      },
      markPoint: {
                data: [
                    {type: 'max', name: '最大值'},
                    {type: 'min', name: '最小值'}
                ]
            },
    });
    this.humiserieslist.push({
      name: "湿度",
      type: "line",
      data: [],
      areaStyle: {opacity: 0.8,
        color: {
          colorStops: [{ 
            offset: 0,
             color: "rgba(1,191,236)"
          },{ 
            offset: 1,
            color: "rgba(84, 112, 198)"
           
          }
          ],
           x: 0,
           y: 0,
           x2: 0,
           y2: 1,
          type: "linear",
          global:false}
      },
      markPoint: {
                data: [
                    {type: 'max', name: '最大值'},
                    {type: 'min', name: '最小值'}
                ]
            },
      
    })
    this.numberserieslist.push({
      name: "虫子数量",
      type: "line",
      data: [],
      areaStyle: {
        opacity: 0.8,
        color: {
          colorStops: [{ 
            offset: 0,
             color: "rgba(1,191,236)"
          },{ 
            offset: 1,
            color: "rgba(84, 112, 198)"
           
          }
          ],
           x: 0,
           y: 0,
           x2: 0,
           y2: 1,
          type: "linear",
          global:false
        }
        
      },
      markPoint: {
                data: [
                    {type: 'max', name: '最大值'},
                    {type: 'min', name: '最小值'}
                ]
            },
    });
    let timelist = [];
    let thtimelist = [];
    // for (let i = 0; i < 24; i++) {
    //   timelist.push(i.toString() + ":00");
    // }

    let datalist_temp1 = [];
    let datalist_humi1 = [];
    let datalist_number = [];
    for (let entry of this.list) {
      timelist.push(this.GetDays(entry.addTime)+" "+this.GetMinutes(entry.addTime));
      datalist_number.push(entry.numbler);
    }
    temphlist.forEach(e => {
      thtimelist.push(this.GetDays(e.addTime)+" "+this.GetMinutes(e.addTime));
      datalist_temp1.push(e.temp);
      datalist_humi1.push(e.humi);
    });
    this.tempmessage = datalist_temp1[datalist_temp1.length - 1];
    this.humimessage = datalist_humi1[datalist_temp1.length - 1];
    this.numbermessage = datalist_number[datalist_number.length - 1];
    
    this.serieslist[0].data = datalist_temp1;
    this.humiserieslist[0].data = datalist_humi1;
    this.numberserieslist[0].data = datalist_number;

    this.legenddata = JSON.stringify(titlelist);
    this.seriesdata = JSON.stringify(this.serieslist);
    this.humiseriesdata = JSON.stringify(this.humiserieslist);
    this.numberseriesdata = JSON.stringify(this.numberserieslist);
    this.xAxisdata = JSON.stringify(timelist);
    this.temphxAxisdata = JSON.stringify(thtimelist);
    this.showEcharts();
  }
  async getThreshold(){
    var thresholdlist = null;
    this.pagerequest.Id = this.eqid;
    var elist = await this.$store.dispatch({
      type: "equipment/get",
      id: this.eqid,
    }); 
    if(elist.tId !='' && elist.tId != 0){
      thresholdlist = await this.$store.dispatch({
      type: "threshold/get",
      id: elist.tId
    });
     this.maxtemp=thresholdlist.maxtemp;
     this.mintemp=thresholdlist.mintemp;
     this.maxhumi=thresholdlist.maxhumi;
     this.minhumi=thresholdlist.minhumi;
     this.MaxNumber=thresholdlist.maxNumber;
    }
     
  }
  GetMinutes(time) {
    let date = new Date(time);
    let Str =
      this.GetBqMinutes(date.getHours()) +
      ":" +
      this.GetBqMinutes(date.getMinutes());
    return Str;
  }
   GetDays(time) {
    let date = new Date(time);
    let Str =this.GetBqMinutes(date.getMonth()+1)+"."+this.GetBqMinutes(date.getDate()) ;
    return Str;
  }
  GetBqMinutes(str) {
    if (str.toString().length == 1) {
      return "0" + str;
    }
    return str;
  }
  visibleChange(value: boolean) {
    // this.ThisThPaged();
    
    if (!value) {
      this.$emit("input", value);
      this.$emit("title", this.locationName);
    } else {
      let sdata = this.$store.state.equipment.analyseEquipment;
      this.mac = sdata.mac;
      this.eqid = sdata.id;
      this.pagerequest.timetype = 0;
      this.getPage();
      this.getThreshold();
    }
  }

  cancel() {
    //this.getPage();
    this.$emit("input", false);
  }

  showEcharts() {
    this.componentKey += 1;
    this.componentKeyhumi += 1;
  }
  GetByDate(){
    if(this.pagerequest.StartDate.toString()!=""&&this.pagerequest.EndDate.toString()!=""){
       this.pagerequest.mac = this.mac;
       this.pagerequest.timetype = 1;
       this.getPage();
    }
    
  }
  GetByMonth(){
    if(this.monthDate.toString()!=""){
    var currentY = this.monthDate.getFullYear();
    var currentM = this.monthDate.getMonth()+1;
    var lastM = new Date(currentY,currentM,0);
    var lastS = new Date(currentY,currentM-1);
    this.pagerequest.StartDate=lastS;
    this.pagerequest.EndDate=lastM;
    this.pagerequest.mac = this.mac;
    this.pagerequest.timetype = 1;
    this.getPage();
    } 
  }
}
